module.exports = __webpack_public_path__ + "img/32.d59a8a02.svg";